<template>
  <div class="project">
    <nav class="navbar is-mobile is-medium" style="background-color: #30008A;" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <img id="navbar-logo" src="../../assets/projects/mechhive/mechhive.jpg" alt="Logo">
      </div>
    </nav>

    <h1>Work Experience @MechHive - Projects</h1>

    <h2>A Journey of Transformation at MechHive</h2>
    <p>During my tenure at MechHive, I embarked on a remarkable journey into the realm of digital gifting. MechHive, a dynamic startup specializing in gift cards, granted me the privilege to be a part of a transformative chapter in the world of online gift cards.</p>

    <h2>Designing User-Centered Digital Platforms</h2>
    <p>My central role at MechHive was to craft digital platforms with the user firmly at the heart of our designs. These platforms were meticulously developed to provide users with intuitive, visually captivating interfaces, essentially redefining the way people interact with digital gift cards.</p>

    <h2>Reshaping the Gift Card Landscape</h2>
    <p>One of the most significant milestones during my seven months at MechHive was our ambitious mission to introduce a range of services aimed at reshaping the gift card industry. My primary focus revolved around the development of user-friendly interfaces, promising a revolutionized gifting experience.</p>

    <h2>A Collaborative and Innovative Team</h2>
    <p>What made my journey at MechHive truly special was the opportunity to work alongside a dynamic and innovative team. The collaborative atmosphere and unwavering commitment to innovation enabled me to immerse myself in diverse projects and thrilling challenges.</p>

    <h2>Project 1: Skine (https://skine.com/)</h2>
    <p>Skine is a digital code shop that offers games, top-ups, gift cards, and payment cards. I had the honor of leading the design efforts and handling graphical work, in addition to providing valuable support on the frontend. I utilized a combination of powerful tools such as Sketch, Adobe Creative Cloud, and Jira to craft stunning designs that brought Skine to life.</p>
    <br> <br>
    <img src="../../assets/projects/mechhive/skine.png" alt="img">

    <h2>Project 2: Rewarble (https://www.rewarble.com/)</h2>
    <p>Rewarble is a website designed for our customers to trade their "Rewarble Giftcards," which are available through some of MechHive's resellers. These gift cards can be traded for one or more gift cards, depending on the amount of money loaded onto the card at the time of purchase. I took the lead in creating the initial frontend for the page, employing technologies such as Tailwind CSS, HTML, CSS, and JavaScript to deliver an exceptional user experience.</p>
    <br> <br>
    <img src="../../assets/projects/mechhive/rewarble.png" alt="img">

  </div>
</template>

<style>
@import 'project.css';
</style>
